
/* System defined core library */
import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { UtilityService } from '../../services/utility.service';
import { SelectedExamDetailService } from '../../../scheduling/shared/services/selected-exam-detail.service';


@Component({
    selector: 'app-print',
    templateUrl: './print.component.html'
})
export class PrintComponent {

    translateLanguage$: Subscription;

    @Output() public printed: EventEmitter<any> = new EventEmitter();

    /* Constructor declaration with required injected services */
    constructor(private utilityService: UtilityService,
        private translate: TranslateService,
        private selectedExamDetailService: SelectedExamDetailService
    ) {
        translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
        this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
            languageCode => {
                translate.use(languageCode);
            }
        );

    }

    /* Execute window print command */
    print(): void {
        this.utilityService.print();
        this.printed.emit(true);
        $(".print-icon").addClass('no-outline');
    }

    /*handle keyboard event*/
    handleBtnKeyPress(event: any): void {
        this.printed.emit(true);
        // Check to see if enter were pressed
        if (event.key === "Enter") {
            this.print(); // caling print method
        }
    }
}
